import {
    memo,
    useState,
    useEffect
} from 'react'
import { useDashboard } from '@app/layouts/dashboard/Provider'
import { usePermission } from '@shared/hooks/permissions'

import List from './parts/List'
import Add from './parts/Add'
import Form from './parts/Form'
import Refresh from './parts/Refresh'
import EasyProvider from '@shared/components/EasyProvider'
import { AnimatePresence } from 'framer-motion'

export default memo(function PDCDelegates() {
    const [instance, setInstance] = useState(null)
    const [formVisibility, setFormVisibility] = useState(false)
    const { setTitle } = useDashboard()
    const { hasPermission } = usePermission()

    useEffect(() => {
        setTitle('ممثلين الـ PDC')
    }, [])

    return (
        <EasyProvider value={{
            instance,
            setInstance,
            formVisibility,
            setFormVisibility
        }}>
            <List />
            <Refresh />
            {hasPermission('add_pdcdelegate') && <Add />}
            <AnimatePresence>{formVisibility === true && <Form />}</AnimatePresence>
        </EasyProvider>
    )
})
